// QSP KEYS
export const AD = 'ad';
export const AD_ID = 'ad_id';
export const AF_ID = 'afid';
export const AF_ADVERTISING_ID = 'af_advertising_id';
export const CH_PRO = 'ch_pro';
export const FORM_VARIANT = 'form_variant';
export const CONTROL = 'control';
export const FIRST_NAME = 'first_name';
export const FIRSTNAME = 'firstName';
export const LAST_NAME = 'last_name';
export const LASTNAME = 'lastName';
export const EMAIL = 'email';
export const PHONE = 'phone';
export const DATE_OF_BIRTH = 'dateOfBirth';
export const PRELOAD = 'preload';
export const EMBEDDED = 'embedded';
export const APP_VERSION_QSP = 'appVersion';
export const DEVICE_DATA = 'deviceData';
export const REFERRAL_TOKEN = 'referral_token';
export const FORCED_EXPERIMENTS = 'forced_experiments';
export const FORCED_EXPERIMENT = 'forced_experiment';
export const SRC = 'src';
export const DEVICE_ID = 'device_id';
export const UNEMPLOYMENT_WIZARD = 'unemployment';
export const STATE_CODE = 'state_code';
export const USER_ID = 'user_id';
export const EXPERIENCE = 'experience';
export const CJEVENT = 'CJEVENT';
export const PAY_FRIENDS_TOKEN = 'ch_pfid';
export const PAY_FRIENDS_P2P_EXPERIMENT = 'pf_p2p';
export const FORCE_PERSONA_STATUS = 'force_persona_status';
export const UTM_SOURCE = 'utm_source';
export const PROMO_CODE = 'promo';
export const P2P_VERSION_QSP = 'p2p_version';
export const SYNTHETIC_TEST = 'synth_test';
export const BAI = 'bai';
export const RECEIVER_LTO = 'rlto';
export const VALUE_PROP = 'value_prop';
export const LANDING_PAGE_ORIGIN = 'landing_page_origin';

// QSP VALUES
export const CB_AD = '_cb';
export const FB_AD_PREFIX = 'fb_';
export const REWARDS_AD = '_cashrewards';

export const RECEIVER_LTO_V1 = 'v1';
export const RECEIVER_LTO_V2 = 'v2';
export const RECEIVER_LTO_V3 = 'v3';
export const RECEIVER_LTO_V4 = 'v4';

export const MY_PAY = 'mypay';

// Pay Anyone Incentives
export const PAI_AMOUNT = 'pai_amount';
export const PAI_BONUS = 'pai_bonus';
export const PAI_AD_ID = 'ch_paiid';

// Personalization Ad Campaign Type
export const PERSONALIZATION_AD_CAMPAIGN_TYPE = 'personalized';
export const PACT_SPOT_ME = 'spotme';
export const PACT_CB = 'cb';
export const PACT_CB2 = 'cb2';

export const WEB_SOURCE = 'web_source';
